module.exports = __webpack_public_path__ + "img/qrcode.8c87dde6.png";